/**
 * Accepts urls to .js or .css files and creates corresponding prefetch tags for them in the dom
 * @param urlsToPrefetch
 */
export function prefetchAssets(urlsToPrefetch: string[]): void {
  const fragment = document.createDocumentFragment();
  urlsToPrefetch.forEach((asset) => {
    const prefetchTag = document.createElement('link');
    prefetchTag.rel = 'prefetch';
    prefetchTag.href = asset;
    if (asset.endsWith('.js')) {
      prefetchTag.as = 'script';
      prefetchTag.crossOrigin = 'anonymous';
      fragment.appendChild(prefetchTag);
    } else if (asset.endsWith('.css')) {
      prefetchTag.as = 'style';
      fragment.appendChild(prefetchTag);
    }
  });
  document.head.appendChild(fragment);
}
